// ============================================================
//  ENSAMBLADOR DEL CHATBOT
//
//  ✏️  Para editar el contenido, abre el archivo de la sección:
//       data/inicio.ts        → Menú principal
//       data/modulos.ts       → Lista de módulos
//       data/comercial.ts     → Sub-menú Comercial
//       data/logistica.ts     → Sub-menú Logística
//       data/contabilidad.ts  → Sub-menú Contabilidad
//       data/cuentas-cobrar.ts→ Sub-menú Cuentas por Cobrar
//       data/cuentas-pagar.ts → Sub-menú Cuentas por Pagar
//       data/dashboard.ts     → Sub-menú Dashboard
//       data/produccion.ts    → Sub-menú Producción
//       data/acceso.ts        → Problemas de acceso
//       data/reportes.ts      → Reportes y exportaciones
//       data/temas.ts         → Apariencia y temas
//
//  ➕  Para agregar una nueva sección:
//       1. Crea un nuevo archivo en data/ (copia cualquiera)
//       2. Impórtalo aquí abajo
//       3. Agrégalo en 'secciones' con el nombre que usaste en 'llevaA'
// ============================================================

import { INICIO         } from './data/inicio'
import { MODULOS        } from './data/modulos'
import { COMERCIAL      } from './data/comercial'
import { LOGISTICA      } from './data/logistica'
import { CONTABILIDAD   } from './data/contabilidad'
import { CUENTAS_COBRAR } from './data/cuentas-cobrar'
import { CUENTAS_PAGAR  } from './data/cuentas-pagar'
import { DASHBOARD      } from './data/dashboard'
import { PRODUCCION     } from './data/produccion'
import { ACCESO         } from './data/acceso'
import { REPORTES       } from './data/reportes'
import { TEMAS          } from './data/temas'

export const CHATBOT_DATA = {

  // Nombre del asistente que aparece en la cabecera del chat
  botName: 'Asistente TSI BETA',

  // Mensaje que ve el usuario al abrir el chat
  welcomeMessage: '¡Hola! Soy el asistente virtual de Admin TSI. ¿En qué puedo ayudarte?',

  // Texto que se muestra cuando se sugiere contactar a soporte
  contactInfo: '💬 Si el problema persiste, comunícate con soporte técnico de TSI.',

  secciones: {
    inicio:        INICIO,
    modulos:       MODULOS,
    comercial:     COMERCIAL,
    logistica:     LOGISTICA,
    contabilidad:  CONTABILIDAD,
    cuentasCobrar: CUENTAS_COBRAR,
    cuentasPagar:  CUENTAS_PAGAR,
    dashboard:     DASHBOARD,
    produccion:    PRODUCCION,
    acceso:        ACCESO,
    reportes:      REPORTES,
    temas:         TEMAS,
  }
}
